export default {
	getProvider : (state) => (val, by = 'slug') => {
		return state.providers.find(p => p[ by ] === val)
	},
	getIntegration : (state) => (val, by = 'slug') => {
		return state.integrations.find(p => p[ by ] === val)
	},
}
